import { render, staticRenderFns } from "./SmartTablePagination.vue?vue&type=template&id=c8f06644&scoped=true"
import script from "./SmartTablePagination.vue?vue&type=script&lang=js"
export * from "./SmartTablePagination.vue?vue&type=script&lang=js"
import style0 from "./SmartTablePagination.vue?vue&type=style&index=0&id=c8f06644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f06644",
  null
  
)

export default component.exports